import * as css from './PermissionsItem.css';
import {useTranslation} from 'react-i18next';
import CommitteePopup from '../committeePopup/CommitteePopup';
import useShow from '../../../../hooks/useShow';
import ModeBtn from '../../../../component/modeBtn/ModeBtn';
import {useSelector} from 'react-redux';
import {updateClubPermission} from '../../../../redux/account/accountActions';

function PermissionsItemClub({permission,disabled} ) {
    const {t} =useTranslation('permission');
    const popupShow = useShow();
    const consumerClubs = useSelector(state => state.account.consumerClubs);
    const userClubPermission = consumerClubs?.find(club => club.clubId === permission.clubId);

    const handleOpenPopup = async () => {
        if(userClubPermission?.token) {
            const currentStatus = userClubPermission.status;
            await updateClubPermission({
                ...userClubPermission,
                status: currentStatus === 1 ? 0 : 1
            });
        }
        else {
            popupShow.open();
        }

    };
    const editIcon = () => {
        popupShow.open();

    };
    return (<>
        <css.item disabled={disabled}>
            <css.right>
                <css.name>{t(permission.clubName)}</css.name>
                {t(`${permission.clubName}Desc`)}
            </css.right>
            <css.actionsContainer>
                <css.editIcon onClick={editIcon} />
                <ModeBtn click={handleOpenPopup}
                    status={userClubPermission?.status || 0}
                />
                {popupShow.isOpen&&<CommitteePopup permission={userClubPermission || permission} popupShow={popupShow} />}
            </css.actionsContainer>

        </css.item>
    </>
    );
}

export default PermissionsItemClub;
